import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-primary-700 bg-primary-100 rounded-full mb-3">
            Getting Started
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            What Is Basetao Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Basetao Spreadsheet is a curated resource system helping users discover products, compare options, understand quality checks and make better purchasing decisions with organized, structured data.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-start">
          <div className="bg-background-50 rounded-lg border border-secondary-200/60 p-6 md:p-8">
            <h3 className="font-heading text-xl font-bold text-foreground-900 mb-4">
              How Basetao Spreadsheet Transforms Your Shopping
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Traditional online shopping requires visiting dozens of individual product pages, manually comparing prices, and piecing together scattered information. Basetao Spreadsheet consolidates all of this into a single, organized system where you can quickly scan through products, compare options side by side, and access quality control insights that would otherwise take hours to gather.
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Whether you are a first-time shopper looking for guidance or an experienced buyer wanting to streamline your research process, <strong>Basetao Spreadsheet</strong> provides the structured framework you need to make confident, well-informed purchasing decisions.
            </p>
            <Link
              to="/basetao-spreadsheet-guide-2026"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
            >
              Read the Complete Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="bg-background-50 rounded-lg border border-secondary-200/60 overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-secondary-100">
                  <th className="text-left px-5 py-3.5 font-semibold text-foreground-800">Feature</th>
                  <th className="text-left px-5 py-3.5 font-semibold text-foreground-800">Traditional Searching</th>
                  <th className="text-left px-5 py-3.5 font-semibold text-primary-700">Basetao Spreadsheet</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: 'Product Discovery', traditional: 'Slow, manual', spreadsheet: 'Organized database' },
                  { feature: 'Price Research', traditional: 'Page-by-page', spreadsheet: 'Easy comparison' },
                  { feature: 'QC Information', traditional: 'Limited access', spreadsheet: 'Structured, clear' },
                  { feature: 'Beginner Friendly', traditional: 'Low', spreadsheet: 'High' },
                  { feature: 'Data Updates', traditional: 'Scattered', spreadsheet: 'Centralized' },
                ].map((row, i) => (
                  <tr key={row.feature} className={i % 2 === 0 ? 'bg-background-50' : 'bg-secondary-50/50'}>
                    <td className="px-5 py-3 font-medium text-foreground-800">{row.feature}</td>
                    <td className="px-5 py-3 text-foreground-600">{row.traditional}</td>
                    <td className="px-5 py-3 text-primary-700 font-medium">{row.spreadsheet}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}